import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { ReportService } from '../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import * as ExportDataModule from 'highcharts/modules/export-data';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';

declare var require: any;
const moment = require('moment');
const HighchartsExporting = require('highcharts/modules/exporting');

HighchartsExporting(Highcharts);

ExportDataModule(Highcharts);
@Component({
  selector: 'report-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.css'],
  providers: [ReportService, ExportCustomService],
})
export class TicketComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public backgroundList = ['#fee4cb', '#e9e7fd', '#dbf6fd', '#ffd3e2', '#c8f7dc'];

  public dataTicketTrendKeyLists: any = [];

  public dataSessionLeaveKeyLists: any = [
    { key: 'short', name: 'Cuộc gọi ngắn' },
    { key: 'long', name: 'Cuộc gọi dài' },
  ];

  public modelFilter: any = {
    from_date: new Date(new Date().setDate(new Date().getDate() - 7)),
    to_date: new Date(),
  };
  public dataTicketTrend: any = null;
  public dataSessionLeave: any = null;
  public TicketTrendCategories: any = [];
  public SessionLeaveCategories: any = [];
  public exportType = {
    TicketTrend: 'TicketTrend',
    SessionLeave: 'SessionLeave',
    ProcessTicket: 'ProcessTicket',
  };
  public DataTicketTrendTotal: any = 0;
  public dataSummary: any = {};
  public optionsSourceData: any = {};
  public optionsCustomer: any = {};
  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  public dataTimeProcessTicket: any = [];
  public dataTimeProcessTicketExport: any = [];
  public isLoading: boolean = false;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    const payload = {
      from_date: moment(this.modelFilter.from_date).format('YYYY-MM-DD'),
      to_date: moment(this.modelFilter.to_date).add(1, 'day').format('YYYY-MM-DD'),
    };
    this.reportService.ticketv2(payload).subscribe(
      res => {
        if (res && res.data && res.data.length > 1) {
          this.gennerateDataTicketTrend(res.data[0]);
          this.gennerateDataSessionLeave(res.data[1]);
          this.isLoading = false;
        } else {
          console.error('Invalid response data format');
        }
      },
      error => {
        this.dataSessionLeave = null;
        this.dataTicketTrend = null;
        console.error('Error fetching ticket data:', error);
        this.isLoading = false;
      }
    );

    this.reportService
      .summaryTimeProcessTicket({
        date_to: payload.to_date,
        date_from: payload.from_date,
      })
      .subscribe(
        res => {
          console.log(res);
          if (res && res.data) {
            this.gennerateDataTimeProcessTicket(res.data);
          } else {
            console.error('Invalid response data format');
          }
        },
        error => {
          this.dataSessionLeave = null;
          this.dataTicketTrend = null;
          console.error('Error fetching ticket data:', error);
          this.isLoading = false;
        }
      );
  }

  gennerateDataTimeProcessTicket(seriesTimeProcessTicket) {
    this.dataTimeProcessTicketExport = [];
    let datas = [];
    Object.keys(seriesTimeProcessTicket).forEach(key => {
      if (key.startsWith('percent_')) {
        let keys = key.replace('percent_', '');
        let label = '';

        if (keys == 'an_hour') {
          label = '0-1 hrs';
        }
        if (keys == 'an_half_of_day') {
          label = '1-12 hrs';
        }
        if (keys == 'a_day') {
          label = '12-24 hrs';
        }

        if (keys == 'a_three_days') {
          label = '1-3 days';
        }
        if (keys == 'more_days') {
          label = '>=3 days';
        }
        if (keys == 'an_half_of_day') {
          keys = 'a_half_of_day';
        }
        this.dataTimeProcessTicketExport.push({
          title: label,
          percent: Number(seriesTimeProcessTicket[key].toFixed(1)),
          count: seriesTimeProcessTicket[keys],
        });
        datas.push({
          title: label,
          data: Number(seriesTimeProcessTicket[key].toFixed(1)),
        });
      }
    });

    const ProcessTicketElement = document.getElementById('ProcessTicket');
    const widthProcessTicket = ProcessTicketElement ? ProcessTicketElement.offsetWidth : 200;
    this.dataTimeProcessTicket = {
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: datas.map(value => value.title),
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: ' ',
        },
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo thời gian xử lý trung bình ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo thời gian xử lý trung bình ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo thời gian xử lý trung bình ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo thời gian xử lý trung bình ${formattedDate}`,
                  });
                },
              },

              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.ProcessTicket);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16, // Di chuyển nút lên trên 40px
          },
        },
      },
      chart: {
        type: 'column',
        height: 500,
        width: widthProcessTicket - 100,
      },
      title: {
        text: ` `,
      },
      plotOptions: {
        column: {
          borderRadius: 4,
          pointWidth: 30, // Giảm độ rộng của cột
          dataLabels: {
            enabled: true,
            format: '{y}%',
            style: {
              fontSize: '12px',
            },
          },
        },
      },
      series: [
        {
          name: '  ',
          colorByPoint: true,
          data: datas.map(e => e.data),
          colors: ['#F44336', '#0D47A1', '#26C6DA', '#FFEB3B', '#757575'],
        },
      ],
    };
  }

  gennerateDataSessionLeave(seriesSessionLeave) {
    this.dataSessionLeaveKeyLists.map((value: any, index: any) => {
      let datas = [];
      seriesSessionLeave.map((val: any) => {
        if (value.key == 'short') {
          datas.push(val.data[0]);
        }
        if (value.key == 'long') {
          datas.push(val.data[1]);
        }
      });
      value.data = datas;
      return {
        name: value.name,
        data: datas,
      };
    });

    this.SessionLeaveCategories = seriesSessionLeave.map((val: any) => val.label);
    const sessionLeaveElement = document.getElementById('sessionLeave');
    const widthSessionLeave = sessionLeaveElement.offsetWidth;
    this.dataSessionLeave = {
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo phiên bị bỏ rơi ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo phiên bị bỏ rơi ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo phiên bị bỏ rơi ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo phiên bị bỏ rơi ${formattedDate}`,
                  });
                },
              },

              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.SessionLeave);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16, // Di chuyển nút lên trên 40px
          },
        },
      },
      chart: {
        type: 'column',
        height: 500,
        width: widthSessionLeave,
      },
      title: {
        text: '   ',
      },
      xAxis: {
        categories: this.SessionLeaveCategories.slice(1),
        title: {
          text: '  ',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Số lượng',
        },
        stackLabels: {
          enabled: false,
        },
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Tổng: {point.stackTotal}',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: this.dataSessionLeaveKeyLists.map(a => {
        a.data = a.data.slice(1);
        return a;
      }),
      colors: ['#0077b6', '#d9d9ff'],
    };
  }

  gennerateDataTicketTrend(seriesTicketTrend) {
    let datas = [];

    this.dataTicketTrendKeyLists = [];

    seriesTicketTrend.map(e => {
      e.data.result.map(a => {
        let check = this.dataTicketTrendKeyLists.find(c => c.key == a.key);
        if (check) {
          let checkIndex = this.dataTicketTrendKeyLists.findIndex(c => c.key == a.key);
          if (checkIndex !== -1) {
            this.dataTicketTrendKeyLists[checkIndex].name = a.title;
          }
        } else {
          this.dataTicketTrendKeyLists.push({ key: a.key, name: a.title });
        }
      });
    });

    datas = this.dataTicketTrendKeyLists.map((value: any, index: any) => {
      let datas = [];
      seriesTicketTrend.map((val: any) => {
        let data = val.data.result.find((e: any) => e.key == value.key);
        datas.push(data ? data.count : 0);
      });
      value.data = datas;
      return {
        name: value.name,
        data: datas,
      };
    });
    this.DataTicketTrendTotal = 0;

    this.TicketTrendCategories = seriesTicketTrend.map((val: any) => {
      this.DataTicketTrendTotal += val.data.total;
      return val.month;
    });

    this.DataTicketTrendTotal = this.DataTicketTrendTotal.toLocaleString('de-DE');

    const ticketTrendElement = document.getElementById('ticketTrend');
    const widthTicketTrend = ticketTrendElement.offsetWidth;
    this.dataTicketTrend = {
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo xu hướng ticket ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo xu hướng ticket ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo xu hướng ticket ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo xu hướng ticket ${formattedDate}`,
                  });
                },
              },

              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.TicketTrend);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16, // Di chuyển nút lên trên 40px
          },
        },
      },
      chart: {
        type: 'column',
        height: 440,
        width: widthTicketTrend,
      },
      title: {
        text: '   ',
      },
      xAxis: {
        categories: this.TicketTrendCategories,
        title: {
          text: '  ',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Số lượng',
        },
        stackLabels: {
          enabled: false,
        },
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Tổng: {point.stackTotal}',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: datas,
      colors: [
        '#2d9cdb',
        '#90be6d',
        '#f94144',
        '#8dd3c7',
        '#b3de69',
        '#fdb462',
        '#ff9f1c',
        '#6a4c93',
        '#1a936f',
        '#c9184a',
        '#4361ee',
        '#ff6b6b',
        '#4ecdc4',
      ],
    };
  }

  onDateChange(key, value): void {
    this.loadData();
  }

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let title = '';
    let data: any = {};
    switch (type) {
      case this.exportType.TicketTrend:
        this.TicketTrendCategories.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Thời gian'] = value;
          this.dataTicketTrend.series.map((val: any) => {
            data_json[val.name] = val.data[index];
          });
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Báo cáo xu hướng ticket';
        data['column'] = [
          'STT',
          'Thời gian',
          ...Array.from(new Set(this.dataTicketTrendKeyLists.map((val: any) => val.name))),
        ];
        data['isDate'] = true;
        data['dates'] =
          `Từ: ${moment().subtract(6, 'months').startOf('month').format('YYYY-MM')} - Đến: ${moment().endOf('month').format('YYYY-MM')}`;
        data['colWidths'] = [
          10,
          24,
          ...Array.from(new Set(this.dataTicketTrendKeyLists.map((val: any) => val.name))).map(() => 24),
        ];
        title = 'Báo cáo xu hướng ticket';
        break;

      case this.exportType.SessionLeave:
        this.SessionLeaveCategories = this.SessionLeaveCategories.slice(1);
        let datas = this.dataSessionLeave.series;

        this.SessionLeaveCategories.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Thời gian'] = value;

          datas.map((val: any) => {
            data_json[val.name] = val.data[index];
          });
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Báo cáo phiên bị bỏ rơi';
        data['column'] = ['STT', 'Thời gian', ...this.dataSessionLeaveKeyLists.map((val: any) => val.name)];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment(this.modelFilter.from_date).format('YYYY-MM-DD')} - Đến ngày: ${moment(this.modelFilter.to_date).format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 24, ...this.dataSessionLeaveKeyLists.map((val: any) => 24)];
        title = 'Báo cáo phiên bị bỏ rơi';
        break;

      case this.exportType.ProcessTicket:
        this.dataTimeProcessTicketExport.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Thời gian'] = value.title;
          data_json['Số lượng'] = value.count;
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Báo cáo thời gian xử lý trung bình';
        data['column'] = ['STT', 'Thời gian', 'Số lượng'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment(this.modelFilter.from_date).format('YYYY-MM-DD')} - Đến ngày: ${moment(this.modelFilter.to_date).format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 24, 24];
        title = 'Báo cáo thời gian xử lý trung bình';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  generateDatenow() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // getMonth() trả về giá trị từ 0-11, nên cần cộng thêm 1
    const year = currentDate.getFullYear();
    const formattedDate = `Tháng ${month} - ${year}`;
    return formattedDate;
  }

  ngAfterViewInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/ticket/ticket.component.ts